"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DumbappResultVariable = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _fastDeepEqual = _interopRequireDefault(require("fast-deep-equal"));
var _DumbappResultData = require("./DumbappResultData");
class DumbappResultVariable {
  constructor() {
    (0, _defineProperty2.default)(this, "settings", {});
    (0, _defineProperty2.default)(this, "type", "dumbapp-result");
    (0, _defineProperty2.default)(this, "valueType", "dumbapp-result");
    (0, _defineProperty2.default)(this, "currentValue", null);
    (0, _defineProperty2.default)(this, "ref", void 0);
    (0, _defineProperty2.default)(this, "label", "Dumbapp Result");
    (0, _defineProperty2.default)(this, "shortcode", void 0);
    (0, _defineProperty2.default)(this, "trackerValue", void 0);
  }
  dependencies(params, resolver) {
    let shortcode = resolver.resolveString(params.shortcode);
    return {
      shortcode
    };
  }
  getValue(ref, deps) {
    this.shortcode = deps.shortcode;
    this.ref = ref;
    if (!this.currentValue && this.trackerValue) {
      let sub = this.trackerValue(this);
      if (sub) {
        this.currentValue = new _DumbappResultData.DumbappResultData(sub);
      }
    }
    ref.value = this.currentValue;
  }
  update(submission) {
    if (!submission) {
      this.currentValue = null;
      if (this.ref) {
        this.ref.value = null;
      }
    } else {
      let value = new _DumbappResultData.DumbappResultData(submission);
      if (!(0, _fastDeepEqual.default)(value, this.currentValue)) {
        this.currentValue = value;
        if (this.ref) {
          this.ref.value = this.currentValue;
        }
      }
    }
  }
}
exports.DumbappResultVariable = DumbappResultVariable;
//# sourceMappingURL=DumbappResultVariable.js.map